import { Component, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerComponent } from "../../layout/spinner/spinner.component";
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/language/language.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FileManagerComponent } from "../../layout/file-manager/file-manager.component";
import { environment } from '../../../../environments/environment'
@Component({
  selector: 'app-slider',
  imports: [SpinnerComponent, CommonModule, DragDropModule, ReactiveFormsModule, FileManagerComponent],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.css'
})
export class SliderComponent {

  load = false
  data: any
  error = false

  currentLang = 'ge'
  loadDeleteId: number | null = null;

  isEdit = false
  editBtnLoad = false
  @ViewChild('formModal') formModalTemplate!: TemplateRef<any>;
  form: FormGroup;

  @ViewChild('fileManagerModal') fileManagerModal!: TemplateRef<any>;
  private filePickerCallback: ((url: string) => void) | null = null;

  domain = environment.apiDomain

  constructor(
      private langService: LanguageService,
      private modalService: NgbModal,
      private GalleryService: GalleryService,
      private ToastrService: ToastrService,
      private fb: FormBuilder
  ){
    this.currentLang = this.langService.getLanguage();
    this.langService.currentLanguage$.subscribe((lang) => {
      this.currentLang = lang;
      this.get()
    });
    this.get()
    this.form = this.fb.group({
      id: [null],
      title: '',
      show_title: '',
      description: '',
      author: null,
      link: '',
      image1: null,
      visibility: 1,
    });
  }

  get(){
    this.load = true
    this.GalleryService.get().subscribe(
      (res: any) => {
        this.load = false
        this.error = false
        this.data = res
        console.log(this.data)
      },
      (error: any) => {
        this.error = true
        this.load = false
      }
    )
  }
    
 add(){
    this.isEdit = false
    this.form.reset({
      id: null,
      title: '',
      show_title: '',
      description: '',
      author: null,
      link: '',
      image1: null,
      visibility: 1,
    });

    this.modalService.open(this.formModalTemplate, { size: 'lg' });
  }

  edit(item: any){
    this.isEdit = true
    console.log(item)
    this.form.patchValue({
      id: item.id || null,
      title: item.title,
      show_title: item.show_title,
      description: item.description || null,
      author: item.author || null,
      link: item.link || null,
      image1: item.image1 || null,
      visibility: item.visibility ?? 1
    });
    this.modalService.open(this.formModalTemplate, { size: 'lg' })
  }

  openFileManagerForImage() {

    this.modalService.open(this.fileManagerModal, {
      size: 'xl',
      windowClass: 'custom-filemanager-modal',
      fullscreen: true
    });

    this.filePickerCallback = (url: string) => {
      this.form.patchValue({ image1: url });
      // modalRef.close();
    };
  }

  onFileSelectedFromManager(url: string, modal: any) {
    if (this.filePickerCallback) {
      this.filePickerCallback(url);
      this.filePickerCallback = null;
    } else {
      this.form.patchValue({ image1: url });
    }
    modal.close();
  }


  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.data, event.previousIndex, event.currentIndex);

    const updated = this.data.map((item: any, index: number) => ({
      ...item,
      position: index + 1
    }));

    this.GalleryService.updatePositions({ items: updated }).subscribe(
      () => this.ToastrService.success('პოზიცია წარმატებით შეიცვალა'),
      () => this.ToastrService.error('მოხდა შეცდომა პოზიციის ცვლილების დროს')
    );
  }

  delete(data: any) {
    if (confirm('დარწმუნებული ხარ რომ გინდა წაშლა?')) {

      this.loadDeleteId = data.id;
      this.GalleryService.delete(data.id).subscribe({
        next: () => {
          this.ToastrService.success('წარმატებით წაიშალა');
          this.get();
          this.loadDeleteId = null;
        },
        error: (err: any) => {
          console.error(err);
          this.ToastrService.error('შეცდომა წაშლისას');
          this.loadDeleteId = null;
        }
      });

    }
  }

  save(modal: any){
    if(!this.isEdit){
      this.editBtnLoad = true
      this.GalleryService.update(this.form.value).subscribe(
        (res: any) => {
          this.editBtnLoad = false
          this.ToastrService.success('წარმატებით შეინახა')
          this.get()
        },
        () => {
          this.editBtnLoad = false
          this.ToastrService.error('მოხდა შეცდომა შენახვისას')
        }
      )
    }else {
      this.editBtnLoad = true
      this.GalleryService.store(this.form.value).subscribe(
        (res: any) => {
          this.editBtnLoad = false
          this.ToastrService.success('წარმატებით შეინახა')
          this.get()
        },
        () => {
          this.editBtnLoad = false
          this.ToastrService.error('მოხდა შეცდომა შენახვისას')
        }
      )
    }

  }


getFullImageUrl(imagePath: string): string {
      if (!imagePath) return '';

      // დროებით არ ცვლის დომენს, უბრალოდ თუ სრული URL არის, 그대로 დააბრუნე
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
      }

      // თუ რელატიური ბმულია, დროებით დაუმატე არსებული დომენი (მაგ. აჯარა)
      return `${this.domain}${imagePath.replace(/^\/+/, '')}`;
    }

}
